import fs from 'fs';
import { DialogInstance, DialogPlugin } from 'tdesign-vue';
import { i18n_t } from '@/locales/i18n';
import { CoSyncTaskConfig } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import smh from '@/renderer/scripts/smh';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export function useSelectFolderConfirm() {
  async function confirm(isCreateBaseLocal: boolean, taskConfig: CoSyncTaskConfig): Promise<boolean> {
    const isLocalConfirm = await checkLocal(isCreateBaseLocal, taskConfig);
    if (!isLocalConfirm) {
      return false;
    }

    const isRemoteConfirm = await checkRemote(isCreateBaseLocal, taskConfig);
    if (!isRemoteConfirm) {
      return false;
    }

    return true;
  }

  async function checkLocal(isCreateBaseLocal: boolean, taskConfig: CoSyncTaskConfig): Promise<boolean> {
    // 以远端为准时候，如果本地目录存在，确认是否合并
    if (!isCreateBaseLocal && fs.existsSync(taskConfig.syncPath.localPath)) {
      const confrim = new Promise<boolean>((resolve, reject) => {
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: i18n_t('请确认'),
          body: i18n_t('本地目标路径已存在同名文件夹，是否合并'),
          width: '400px',
          closeOnOverlayClick: false,
          closeOnEscKeydown: false,
          closeBtn: false,
          onConfirm() {
            dialog.hide?.();
            resolve(true);
          },
          onCancel() {
            dialog.hide?.();
            resolve(false);
          },
        });
      });

      const ret = await confrim;
      if (!ret) return false;
    }

    return true;
  }

  async function checkRemote(isCreateBaseLocal: boolean, taskConfig: CoSyncTaskConfig): Promise<boolean> {
    if (!isCreateBaseLocal) return true;

    // 以本地为准时，如果远端目录存在，确认是否合并
    // 检查是否存在同名文件夹
    let existFolder = false;
    try {
      await smh.commonAPI.inspectDirectory({
        spaceId: taskConfig.syncPath.spaceId,
        dirPath: taskConfig.syncPath.remotePath,
      });
      existFolder = true;
    } catch (e: any) {
      logger.ui('checkRemote inspectDirectory', e);
      existFolder = false;
    }

    if (!existFolder) return true;

    // 存在同名文件夹，弹窗确认
    const confrim = new Promise<boolean>((resolve, reject) => {
      const dialog: DialogInstance = CustomDialog.confirm({
        theme: 'warning',
        header: i18n_t('请确认'),
        body: i18n_t('云端目标路径已存在同名文件夹，是否合并?'),
        width: '400px',
        closeOnOverlayClick: false,
        closeOnEscKeydown: false,
        closeBtn: false,
        onConfirm() {
          dialog.hide?.();
          resolve(true);
        },
        onCancel() {
          dialog.hide?.();
          resolve(false);
        },
      });
    });

    const ret = await confrim;
    if (!ret) return false;

    return true;
  }

  return {
    confirm,
  };
}
